import { toast } from 'react-toastify'

import { api } from 'api'
import { Info, Success } from 'constants/actionMessages'
import { BusinessType, BusinessTypesGetAllParams } from 'interfaces/api/templates.interfaces'
import {
  CreateBusinessTypeParams,
  RemoveBusinessTypeParams,
  UpdateBusinessTypeParams,
} from 'interfaces/store/templates.interfaces'
import { createAction, createAsyncThunk } from 'modules/store'
import { ValidationErrorsApi } from 'packages/api'
import { businessTypesMapper } from 'utils/businessTypesMapper'

export const getAllBusinessTypes = createAsyncThunk(
  'templates/getAllBusinessTypes',
  async (params: BusinessTypesGetAllParams | undefined, { rejectWithValue }) =>
    api.templates.businessTypes.getAll(params).catch((error) => rejectWithValue(error.message)),
)

export const getBusinessType = createAsyncThunk('templates/getBusinessType', async (id: number, { rejectWithValue }) =>
  api.templates.businessTypes.getSingle(id).catch((error) => rejectWithValue(error.message)),
)

export const setSingleBusinessType = createAction<BusinessType | null>('templates/setSingleBusinessType')
export const setBusinessTypeValidationErrors = createAction<ValidationErrorsApi | null>(
  'templates/setBusinessTypeValidationErrors',
)

export const createBusinessType = createAsyncThunk(
  'templates/createBusinessType',
  async (params: CreateBusinessTypeParams, { rejectWithValue, dispatch }) =>
    api.templates.businessTypes
      .create(businessTypesMapper(params.data))
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setBusinessTypeValidationErrors(null))
        toast.success(Success.BusinessTypeCreated)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setBusinessTypeValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const updateBusinessType = createAsyncThunk(
  'templates/updateBusinessType',
  async (params: UpdateBusinessTypeParams, { rejectWithValue, dispatch }) =>
    api.templates.businessTypes
      .update(params.id, businessTypesMapper(params.data))
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setBusinessTypeValidationErrors(null))
        toast.success(Success.Save)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setBusinessTypeValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const removeBusinessType = createAsyncThunk(
  'templates/removeBusinessType',
  async (params: RemoveBusinessTypeParams, { rejectWithValue }) =>
    api.templates.businessTypes
      .remove(params.id)
      .then(() => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        toast.info(Info.BusinessTypeRemoved)
        return
      })
      .catch((error) => rejectWithValue(error.message)),
)
